/**
 * Feature flags for LoanKnow.
 *
 * MVP scope is borrower-side: assessment → recommendation → forward to LO/realtor →
 * full application → dynamic doc list → Owen underwriting verdict.
 *
 * Phase-2 features (lender marketplace, lender bidding, human underwriter chat) live in the
 * codebase but are gated off here so the borrower journey ends at Owen's underwriting verdict.
 *
 * Flip a flag to true to expose the feature; everything reads from this single module.
 */

const env = (key) => {
  try {
    return import.meta?.env?.[key];
  } catch {
    return undefined;
  }
};

const truthy = (v) => v === true || v === 'true' || v === '1';

const isUnset = (v) => v === undefined || v === null || String(v).trim() === '';

const rawApplicationLive = env('VITE_FEATURE_APPLICATION_LIVE');

export const LK_FEATURES = {
  // Master switch for the borrower application. When unset, the real /apply
  // flow is enabled (authenticated users can open /apply?resume= from dashboard)
  // extra env wiring). Set VITE_FEATURE_APPLICATION_LIVE=false (or 0) for
  // pre-launch: CTAs open ComingSoonModal and /apply redirects home.
  applicationLive: isUnset(rawApplicationLive) ? true : truthy(rawApplicationLive),

  // Phase 2: lenders bid for the borrower's file. Off until we have >= 5 lenders.
  lenderMarketplace: truthy(env('VITE_FEATURE_LENDER_MARKETPLACE')),

  // Phase 2: borrower can choose human underwriter instead of Owen AI.
  humanUnderwriter: truthy(env('VITE_FEATURE_HUMAN_UNDERWRITER')),

  // Phase 2: marketing metrics that depend on lender_bids data.
  lenderBidsStats: truthy(env('VITE_FEATURE_LENDER_BIDS_STATS')),

  // Phase 2: digital verification (Plaid / Truework / Argyle). UI shows "Coming Soon."
  digitalVerification: truthy(env('VITE_FEATURE_DIGITAL_VERIFICATION')),

  // Floating "AI Analysis" tab (FloatingOwenAssistant). Set VITE_FEATURE_AI_ANALYSIS=true to show.
  aiAnalysis: truthy(env('VITE_FEATURE_AI_ANALYSIS')),

  // Floating "Knowledge Center" tab (FloatingKnowledge). Set VITE_FEATURE_KNOWLEDGE_CENTER=true to show.
  knowledgeCenter: truthy(env('VITE_FEATURE_KNOWLEDGE_CENTER')),

  // V1 six-product triage + field flows (replaces legacy assessment router when true).
  v1ProductMatrix: truthy(env('VITE_V1_PRODUCT_MATRIX')),
};

export default LK_FEATURES;
